(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const INSTANCE_KEY = '__horizonStickyHeaderWithAnnouncement';

    if (window[INSTANCE_KEY] && typeof window[INSTANCE_KEY].destroy === 'function') {
      window[INSTANCE_KEY].destroy();
    }

    const STICKY_CLASS = 'header-sticky';
    const BODY_CLASS = 'header-sticky-active';

    const STICKY_ACTIVATE_OFFSET = 20;
    const STICKY_DEACTIVATE_OFFSET = 32;

    let announcementBar = null;
    let header = null;
    let announcementBottomOffset = 0;
    let ticking = false;
    let resizeTimer = null;
    let isSticky = false;

    function getAnnouncementBar() {
      return document.querySelector(
        '.announcement-bar, .section-announcement-bar, [data-announcement-bar]'
      );
    }

    function getHeader() {
      return document.querySelector(
        '.header-section, .shopify-section-group-header-group header, header'
      );
    }

    function calculateAnnouncementOffset() {
      if (!announcementBar) return 0;

      const rect = announcementBar.getBoundingClientRect();

      return rect.top + window.scrollY + announcementBar.offsetHeight;
    }

    function setStickyState(nextStickyState, force = false) {
      if (!header) return;

      if (!force && isSticky === nextStickyState) return;

      isSticky = nextStickyState;

      header.classList.toggle(STICKY_CLASS, isSticky);
      document.body.classList.toggle(BODY_CLASS, isSticky);
    }

    function syncStickyStateFromDOM() {
      if (!header) return;

      isSticky =
        header.classList.contains(STICKY_CLASS) ||
        document.body.classList.contains(BODY_CLASS);
    }

    function updateStickyHeader() {
      if (!announcementBar || !header) {
        setStickyState(false, true);
        return;
      }

      const scrollY = window.scrollY || window.pageYOffset || 0;

      /**
       * Hard reset at actual top.
       * This guarantees header-sticky-active is removed when user is at page top.
       */
      if (scrollY <= 0) {
        setStickyState(false, true);
        return;
      }

      /**
       * Activate sticky after passing announcement bar.
       */
      if (!isSticky && scrollY >= announcementBottomOffset + STICKY_ACTIVATE_OFFSET) {
        setStickyState(true);
        return;
      }

      /**
       * Deactivate sticky only after scrolling back above the announcement bar
       * with buffer to prevent flickering.
       */
      if (isSticky && scrollY <= announcementBottomOffset - STICKY_DEACTIVATE_OFFSET) {
        setStickyState(false);
      }
    }

    function requestUpdate() {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(function () {
        updateStickyHeader();
        ticking = false;
      });
    }

    function refreshStickyHeader() {
      announcementBar = getAnnouncementBar();
      header = getHeader();

      if (!announcementBar || !header) {
        setStickyState(false, true);
        return;
      }

      syncStickyStateFromDOM();

      announcementBottomOffset = calculateAnnouncementOffset();

      updateStickyHeader();
    }

    function handleResize() {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        refreshStickyHeader();
      }, 150);
    }

    function handleSectionLoad() {
      window.setTimeout(function () {
        refreshStickyHeader();
      }, 100);
    }

    function initStickyHeader() {
      refreshStickyHeader();

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', handleResize);
      window.addEventListener('load', refreshStickyHeader);
      document.addEventListener('shopify:section:load', handleSectionLoad);
    }

    function destroyStickyHeader() {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('load', refreshStickyHeader);
      document.removeEventListener('shopify:section:load', handleSectionLoad);

      window.clearTimeout(resizeTimer);

      /**
       * Optional cleanup.
       * Remove this if you want the sticky state to persist between section reloads.
       */
      if (header) {
        header.classList.remove(STICKY_CLASS);
      }

      document.body.classList.remove(BODY_CLASS);
    }

    window[INSTANCE_KEY] = {
      refresh: refreshStickyHeader,
      destroy: destroyStickyHeader
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyHeader, { once: true });
    } else {
      initStickyHeader();
    }
})();

// ------------------



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
